export const findYourNextCarType = 'findYourNextCar';
export const bookYourServiceType = 'bookYourService';
export const flexItemsValues = {
    default: ['1', '2', '0 0 100%', '1', '0 0 80%'],
};
export const setPadding = (padding) => (`padding: ${padding}px;`);
export const setMargin = (margin) => (`margin: ${margin}px;`);
